"use client"
import React from "react";
import { Marker } from "react-map-gl/mapbox";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import AmenityIcon from "@/components/categories/AmenityIcon";
import "@/components/shared/AmenityMapIcon.css";
import { useMediaQuery } from "react-responsive";

const AmenityMapIcon = ({ amenityPoint, onClick }) => {
  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });

  if (amenityPoint) {
    return (
      <Marker
        longitude={amenityPoint.location.longitude}
        latitude={amenityPoint.location.latitude}
        onClick={onClick}
      >
        <OverlayTrigger
          key={`${amenityPoint.id}`}
          placement="bottom"
          trigger={isSm ? "click" : ["hover", "focus"]}
          overlay={
            <Tooltip id={`tooltip-${amenityPoint.id}`}>
              <b>{amenityPoint.title}</b>
              <br />
              {amenityPoint.text && <small>{amenityPoint.text}</small>}
            </Tooltip>
          }
        >
          <div className={`amenity-map-icons icons-${amenityPoint.amenities.length}`}>
            {amenityPoint.amenities.map((amenity, index) => {
              return (
                <div key={`amenity-map-icon-${amenityPoint.id}-${index}`} className="amenity-map-icon drop-shadow">
                  <i className={`fa-solid ${amenity.icon}`}></i>
                </div>
              );
            })}
          </div>
        </OverlayTrigger>
      </Marker>
    );
  } else {
    return null;
  }
};
export default AmenityMapIcon;
